<template>
  <v-container fill-height fluid class="background">
    <v-row align="center" justify="center">
      <div class="player-container center">
        <v-card class="player-top-panel transparent">
          <v-card class="transparent">
            <v-card color="white--text transparent font-weight-bold">{{ author }}</v-card>
            <v-card color="white--text transparent font-weight-bold">{{ title }}</v-card>
            <v-btn
              class="ma-0 ptb-2 hash-btn"
              small
              depressed
              color="text5"
              :text="true"
            >#thankingoutloud</v-btn>
          </v-card>
          <v-card class="transparent">
            <v-img class="logo" alt="Dub logo" src="../assets/logo.png" />
          </v-card>
        </v-card>
        <v-row class="avatar" justify="center" align="center">
          <v-avatar size="160">
            <img
              class="withSet"
              src="https://images.unsplash.com/photo-1503983469989-e2cbfd3bfeae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1234&q=80"
            />
          </v-avatar>
        </v-row>
        <v-row class="player-bottom-panel" justify="center" align="center">
          <div class="player-bottom-panel center">
            <v-btn class="rounded-button" elevation="0" color="primary">Share</v-btn>
            <v-btn large fab align-center :text="true" elevation="0" v-on:click="playButtonClick">
              <v-icon color="white" v-if="status !== 'playing'">mdi-play</v-icon>
              <v-icon color="white" v-else>mdi-pause</v-icon>
            </v-btn>
            <v-card flat color="text4--text" class="transparent font-weight-bold">
              10:43
              <span class="opaque">| 15:43</span>
            </v-card>
          </div>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "player",
  props: ["url", "author", "title"],
  data: function() {
    var audio = new Audio();

    return {
      "audio": audio,
      "status": "paused",
      "shouldStartPlaying": false,
      "registeredEvents": false,
    }
  },
  watch: {
    url: function(newValue) {
      console.log("Setting audio url:", newValue);
      this.audio.src = newValue;
      if (this.shouldStartPlaying) {
        this.play();
      }
    },
  },
  methods: {
    playButtonClick: function() {
      if (this.status === "playing") {
        this.pause();
      } else {
        this.play();
      }
    },
    play: function() {
      var _this = this;
      if (!this.registeredEvents) {
        this.registeredEvents = true;
        this.audio.addEventListener("ended", function() {
          _this.ended();
        });
      }
      if (this.audio.src === "") {
        console.log("Delayed play");
        this.shouldStartPlaying = true;
      } else {
        console.log("Play");
        this.audio.play();
        this.shouldStartPlaying = false;
      }
      this.status = "playing";
    },
    pause: function() {
      console.log("Pause");
      this.audio.pause();
      this.status = "paused";
    },
    ended: function() {
      this.status = "paused";
    }
  },
};
</script>

<style scoped>
.background {
  /* temporary */
  background-color: black;
  opacity: 0.8;
}

.player-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40vw;
  max-width: 400px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.player-top-panel,
.player-bottom-panel {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.avatar {
  margin-top: 20px;
}

.rounded-button {
  border-radius: 8px;
}

.v-btn {
  text-transform: none !important;
  font-weight: bold;
}

.opaque {
  opacity: 0.5;
}

.logo {
  width: 32px;
}

.hash-btn {
  background-color: rgba(249, 59, 93, 0.15);
  border-radius: 200px;
}
</style>
